import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
    { code: 'en', name: 'English', flag: '🇬🇧', short: 'EN' },
    { code: 'fr', name: 'Français', flag: '🇫🇷', short: 'FR' },
    { code: 'ar', name: 'العربية', flag: '🇸🇦', short: 'AR' },
    { code: 'es', name: 'Español', flag: '🇪🇸', short: 'ES' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪', short: 'DE' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹', short: 'IT' },
];

export function LanguageSwitcher() {
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const currentLanguage = languages.find(l => l.code === i18n.language) || languages[0];

    useEffect(() => {
        const handler = (e: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
                setIsOpen(false);
            }
        };
        if (isOpen) document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [isOpen]);

    const handleLanguageChange = (code: string) => {
        i18n.changeLanguage(code);
        setIsOpen(false);
    };

    return (
        <div className="relative" ref={dropdownRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center justify-center px-2.5 py-1.5 rounded-lg text-xs font-medium transition-colors text-hig-text-secondary hover:text-hig-text-primary hover:bg-hig-bg-tertiary border border-hig-border"
            >
                {currentLanguage.short}
            </button>

            {isOpen && (
                <div
                    className="absolute top-full mt-1.5 right-0 z-50 overflow-hidden rounded-xl border border-hig-border"
                    style={{
                        width: 170,
                        background: 'var(--menu-bg)',
                        backdropFilter: 'blur(16px)',
                        boxShadow: 'var(--menu-shadow)',
                        padding: 4,
                    }}
                >
                    {languages.map((lang) => {
                        const isActive = i18n.language === lang.code;
                        return (
                            <button
                                key={lang.code}
                                onClick={() => handleLanguageChange(lang.code)}
                                className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-[13px] transition-colors ${
                                    isActive
                                        ? 'font-semibold'
                                        : 'hover:bg-hig-bg-tertiary'
                                }`}
                                style={{
                                    color: isActive
                                        ? 'var(--menu-active-text)'
                                        : 'var(--menu-text-secondary)',
                                    background: isActive
                                        ? 'var(--menu-active-bg)'
                                        : 'transparent',
                                }}
                            >
                                <span style={{ fontSize: 15 }}>{lang.flag}</span>
                                <span>{lang.name}</span>
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
